import { isValid } from "date-fns";

export const isValidDate = (date) => {
  if (!date) {
    return false;
  }

  const validate = (date) => isValid(date) && date.getFullYear() >= 1000;

  if (typeof date === "string") {
    return validate(new Date(date));
  }

  return validate(date);
};
